import Info from '@mui/icons-material/Info';
import { TooltipProps } from '@mui/material';
import { ReactNode } from 'react';

import LightTooltip from './LightTooltip';

interface ComponentProps {
  infoMessage: ReactNode;
  placement?: TooltipProps['placement'];
}

export default function InfoTooltip({
  infoMessage,
  placement = 'bottom-start',
}: ComponentProps) {
  return (
    <LightTooltip arrow title={infoMessage} placement={placement}>
      <Info sx={{ color: '#0003', marginInline: 1 }} />
    </LightTooltip>
  );
}
